module.exports = __webpack_public_path__ + "img/public/SiteIcons/incrementMinus-sign.svg?c1cca7cc";